export const H1 = {
  fontSize: {
    xs: '34px',
    sm: '42px',
    md: '48px',
    lg: '64px',
    xl: '72px'
  },
  lineHeight: {
    xs: '40px',
    sm: '48px',
    md: '58px',
    lg: '74px',
    xl: '88px'
  }
};